<div ngbDropdown placement="bottom-right" display="dynamic">
  <button type="button" class="btn btn-dark btn-sm" [title]="loginService.userInfo?.name || ('anonymous' | translate)"
          ngbDropdownToggle>
    <span class="username">{{ loginService.userInfo?.name }}</span>
    <span class="fas fa-user-circle fa-2x fa-fw" aria-hidden="true"></span>
    <span class="sr-only">{{"User menu" | translate}}</span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <ng-content></ng-content>
    @for (language of languages; track language) {
      <button
        ngbDropdownItem
        (click)="selectLanguage(language)">
        {{ languageName(language) }}
        <span
          [ngClass]="{'fas fa-fw fa-check ms-1': language === selectedLanguage}"></span>
      </button>
    }
    <div class="dropdown-divider"></div>

    <a class="dropdown-item" href="javascript:" (click)="info()">
      {{ "version" | translate }}
    </a>

    <div class="dropdown-divider"></div>

    <a class="dropdown-item" href="javascript:" (click)="loginLogout()" [class.disabled]="isLoginDisabled">
      {{ loginService.userLoggedIn ? ('Logout' | translate) : ('Login' | translate) }}
    </a>
  </div>
</div>
